export default __webpack_public_path__ + "static/media/whatsappicon.7985341d.svg";